import { css } from "lit-element";

export const StofwareText = css`
	p {
		font-size: 1em;
		line-height: 1.8;
		font-weight: 200;
	}

	.t-center {
		text-align: center;
	}

	.t-left {
		text-align: left;
	}

	.t-right {
		text-align: right;
	}

	.t-error {
		color: var(--app-error);
	}
`;
